<div class="container">
  <div class="row">
    <header><app-logo></app-logo></header>
    <main>
      <div class="box box__alt">
        <div class="box__left">
          <h1 class="box__title" [innerHtml]="'OFFER.TITLE' | translate"></h1>
          <app-summary [status]="true"></app-summary>
        </div>
        <div class="box__right">
          <app-form *ngIf="!showOfferTypesForm"></app-form>
          <app-type *ngIf="showOfferTypesForm"></app-type>
        </div>
      </div>
    </main>
    
  </div>
</div>